const projectRevision = process?.env?.DD_VERSION || '';

const globalConfigs = {
  PROJECT_REVISION: projectRevision,
  PROJECT_NAME: 'blog-ui',
  PATH_ASSIGNED: '/blog-ui',
  APP_LAUNCHED: true,

  //Don't change this value before upgrading the base project. This value must be the base version was upgraded.
  FRONTEND_BOILERPLATE_VERSION: '0.1.0',

  WORKLOAD_URL_PROD: 'https://blog-ui.prd.kavak.io',
  WORKLOAD_URL_DEV: 'https://blog-ui.dev.kavak.io',

  MIDDLEEND_URL_PROD: 'https://frontend-poc-middleend.prd.kavak.io',
  MIDDLEEND_URL_DEV: 'https://frontend-poc-middleend.dev.kavak.io',
  MIDDLEEND_URL_LOCAL: 'https://frontend-poc-middleend.dev.kavak.io',
  //MIDDLEEND_URL_LOCAL: "http://localhost:8000",

  ENV_PROD: 'production',
  ENV_DEV: 'development',

  AVAILABLE_SITES_PRD: ['mx', 'cl', 'br', 'ar'],
  AVAILABLE_SITES_DEV: [
    'ae',
    'ae-ar',
    'ar',
    'br',
    'cl',
    'mx',
    'om',
    'om-en',
    'tr',
  ],
  SITES: {
    ae: { id: 'ae', lang: 'en-AE', dir: 'ltr' },
    'ae-ar': { id: 'ae-ar', lang: 'ar-AE', dir: 'rtl' },
    ar: { id: 'ar', lang: 'es-AR', dir: 'ltr' },
    br: { id: 'br', lang: 'pt-BR', dir: 'ltr' },
    cl: { id: 'cl', lang: 'es-CL', dir: 'ltr' },
    co: { id: 'co', lang: 'es-CO', dir: 'ltr' },
    mx: { id: 'mx', lang: 'es-MX', dir: 'ltr' },
    om: { id: 'om', lang: 'ar-OM', dir: 'rtl' },
    'om-en': { id: 'om-en', lang: 'en-OM', dir: 'ltr' },
    sa: { id: 'sa', lang: 'ar-SA', dir: 'rtl' },
    'sa-en': { id: 'sa-en', lang: 'en-SA', dir: 'ltr' },
    pe: { id: 'pe', lang: 'es-PE', dir: 'ltr' },
    tr: { id: 'tr', lang: 'tr-TR', dir: 'ltr' },
  },

  DEVICE_TYPES: { DESKTOP: 'desktop', MOBILE: 'mobile', WEBVIEW: 'webview' },

  AUTH_AUDIENCE: [],
  AUTH_SCOPES: [],

  HEADER_NAMES: {
    DEVICE_TYPE: 'x-device-type',
    WEBVIEW_CLIENT: 'x-webview-client',
    SITE: 'x-kavak-site',
    LANGUAJE: 'x-kavak-lang',
    LANGUAJE_DIRECTION: 'x-kavak-lang-dir',
    KAVAK_TOKEN: 'x-kavak-token',
  },
  COOKIE_NAMES: {
    DEVICE_TYPE: 'x-device-type',
    DEVICE_OS_TYPE: 'x-device-os-type',
    KAVAK_TOKEN: 'x-kavak-token',
    KAVAK_TOKEN_TYPE: 'x-kavak-token-type',
  },

  FETCH_URL_EXPIRATION: {
    SITE: 3600,
    METADATA: 3600,
    CAROUSEL: 3600,
    MENU: 3600,
    FOOTER: 3600,
  },
  LAYOUT_ALTERNATE_URLS: [
    {
      id: 'alternate-es-mx',
      href: 'https://www.kavak.com/mx',
      hrefLang: 'es-MX',
    },
    {
      id: 'alternate-tr-tr',
      href: 'https://www.carvak.com/tr',
      hrefLang: 'tr-TR',
    },
    {
      id: 'alternate-en-us',
      href: 'https://www.kavak.com/',
      hrefLang: 'en-US',
    },
    {
      id: 'alternate-en-ae',
      href: 'https://www.kavak.com/ae',
      hrefLang: 'en-AE',
    },
    {
      id: 'alternate-ar-ae',
      href: 'https://www.kavak.com/ae-ar',
      hrefLang: 'ar-AE',
    },
    {
      id: 'alternate-es-ar',
      href: 'https://www.kavak.com/ar',
      hrefLang: 'es-AR',
    },
    {
      id: 'alternate-pt-br',
      href: 'https://www.kavak.com/br',
      hrefLang: 'pt-BR',
    },
    {
      id: 'alternate-es-cl',
      href: 'https://www.kavak.com/cl',
      hrefLang: 'es-CL',
    },
    {
      id: 'alternate-es-co',
      href: 'https://www.kavak.com/co',
      hrefLang: 'es-CO',
    },
    {
      id: 'alternate-ar-om',
      href: 'https://www.kavak.com/om',
      hrefLang: 'ar-OM',
    },
    {
      id: 'alternate-en-om',
      href: 'https://www.kavak.com/om-en',
      hrefLang: 'en-OM',
    },
    {
      id: 'alternate-es-pe',
      href: 'https://www.kavak.com/pe',
      hrefLang: 'es-PE',
    },
    {
      id: 'alternate-ar-sa',
      href: 'https://www.kavak.com/sa',
      hrefLang: 'ar-SA',
    },
    {
      id: 'alternate-en-sa',
      href: 'https://www.kavak.com/sa-en',
      hrefLang: 'en-SA',
    },
  ],
  COGNITO_BASE_CONFIG: {
    apiVersion: '2016-04-18',
    region: 'us-west-2',
    url: 'https://olimpo-dev-email.auth.us-west-2.amazoncognito.com',
  },
  COGNITO_CLIENTID_DEV: '47dqmecem0kut7tfrhljcf6f9k',
  COGNITO_CLIENTID_PROD: '43romf2sh188acn3celkaajd8b',
  COGNITO_CLIENTID_DEV_WEBVIEW: '3l1e9l1ugs1nsa229600u49kid',
  COGNITO_CLIENTID_PROD_WEBVIEW: '75ngb9cfjjnovog922vr4id8jr',
};

module.exports = globalConfigs;
